<template>
    <modal @close="$emit('close')" :autoshow="true" ref="modal" :is-closeable="isCloseable">
        <template v-slot:title>Edit Tax Withholding</template>

        <template v-slot:subheading>
            <div class="p-1 unpad-x bg-150 rounded">
                <div><span class="text-muted">Employee:</span> {{ employee.full_name }}</div>
                <div><span class="text-muted">Tax:</span> {{ taxConfig.sym_tax.description }}</div>
            </div>
        </template>

        <slot>
            <div>
                <form>
                    <form-errors :errors="formErrors"/>

                    <div class="form-row">
                        <div class="col-12 mb-2">
                            <div class="form-check">
                                <input class="form-check-input" type="checkbox" id="is_exempt" v-model="formData.is_exempt" />
                                <label class="form-check-label" for="is_exempt">Exempt from withholding</label>
                            </div>
                        </div>
                    </div>

                    <div v-if="!formData.is_exempt" class="form-row">
                        <div v-for="param in visibleParameters" :key="param.parameter_name" class="col-12 mb-2">
                            <template v-if="param.regex_type === 'PickList'">
                                <label :for="'param_' + param.parameter_name">{{ param.certificate_line_no }} — {{ param.description }}</label>
                                <select
                                    class="form-control"
                                    :id="'param_' + param.parameter_name"
                                    v-model="formData.tax_data[param.parameter_name]"
                                >
                                    <option value="">--Default--</option>
                                    <option v-for="[val, label] in param.list_values_parsed" :key="val" :value="val">{{ label }}</option>
                                </select>
                                <small v-if="param.help_text" class="form-text text-muted">{{ param.help_text }}</small>
                            </template>
                            <template v-else-if="param.data_type === 'Boolean'">
                                <label :for="'param_' + param.parameter_name">{{ param.certificate_line_no }} — {{ param.description }}</label>
                                <select
                                    class="form-control"
                                    :id="'param_' + param.parameter_name"
                                    v-model="formData.tax_data[param.parameter_name]"
                                >
                                    <option value="">--Default--</option>
                                    <option :value="true">Yes</option>
                                    <option :value="false">No</option>
                                </select>
                                <small v-if="param.help_text" class="form-text text-muted">{{ param.help_text }}</small>
                            </template>
                            <template v-else>
                                <label :for="'param_' + param.parameter_name">{{ param.certificate_line_no }} — {{ param.description }}</label>
                                <input
                                    class="form-control"
                                    :id="'param_' + param.parameter_name"
                                    :type="param.data_type === 'Integer' || param.data_type === 'Dollar' ? 'number' : 'text'"
                                    :step="param.data_type === 'Dollar' ? '0.01' : '1'"
                                    v-model="formData.tax_data[param.parameter_name]"
                                    :placeholder="param.default_value"
                                />
                                <small v-if="param.help_text" class="form-text text-muted">{{ param.help_text }}</small>
                            </template>
                        </div>
                        <div class="col-12 mb-2">
                            <label for="additional_wh">Additional Withholding Amount</label>
                            <input
                                class="form-control"
                                style="max-width: 160px"
                                type="number"
                                step="0.01"
                                min="0"
                                id="additional_wh"
                                v-model="formData.additional_wh"
                                placeholder="0.00"
                            />
                        </div>
                    </div>
                </form>
            </div>
        </slot>

        <template v-slot:footer>
            <div class="form-row">
                <div class="col">
                    <button type="button" class="btn btn-block btn-outline-primary" @click.prevent="close()">Cancel</button>
                </div>
                <div class="col">
                    <button type="submit" class="btn btn-block btn-primary" @click.prevent="onSubmit">Save</button>
                </div>
            </div>
        </template>
    </modal>
</template>

<script>
import ModalMixin from '@/mixins/ModalMixin'
import FormMixin from '@/mixins/Form'

export default {
    mixins: [ModalMixin, FormMixin],
    components: {},
    props: ['client', 'employee', 'taxConfig'],
    computed: {
        visibleParameters() {
            return this.taxConfig.parameters
                .filter(p => p.certificate_line_no)
                .slice()
                .sort((a, b) => a.certificate_line_no.localeCompare(b.certificate_line_no))
        },
    },
    data() {
        return {
            formData: this.makeFormData(),
        }
    },
    methods: {
        makeFormData() {
            const taxData = Object.assign({}, this.taxConfig.tax_data)
            for (const param of this.taxConfig.parameters) {
                if (param.data_type === 'Boolean' && param.parameter_name in taxData) {
                    const v = taxData[param.parameter_name]
                    taxData[param.parameter_name] = (v === true || v === 'true' || v === 'True') ? true : (v === false || v === 'false' || v === 'False') ? false : ''
                }
            }
            return {
                is_exempt: this.taxConfig.is_exempt,
                additional_wh: this.taxConfig.additional_wh,
                tax_data: taxData,
            }
        },
        getFormData() {
            return this.formData
        },
        onSubmit() {
            this.errors = {}
            this.formErrors = []
            this.$api.patch(
                `/clients/${this.client.id}/employees/${this.employee.id}/sym-tax-config/${this.taxConfig.sym_tax.id}`,
                this.getFormData()
            ).then(resp => {
                this.$emit('updated')
                this.close()
            }).catch(errors => {
                this.errors = errors
                this.formErrors = errors.__all__
            })
        },
    }
}
</script>
